<template>
    <div>
        <template v-if="menuItemCode!='JGW-1-4'">
            <warn_record_detail :propId="id"></warn_record_detail>
        </template>
        <template v-else>
            <warn_record_activity_detail :propId="id"></warn_record_activity_detail>
        </template>
        
    </div>
</template>
<script>
import warn_record_detail from './warn_record_detail.vue';
import warn_record_activity_detail from './warn_record_activity_detail.vue';
export default {
    data(){
        return{
            id:'',
            menuItemCode:''
        }
    },
    components:{
        warn_record_detail,
        warn_record_activity_detail
    },
    activated(){
        this.id = this.$route.query.id || '';
        this.menuItemCode = this.$route.query.menuItemCode || '';
    }
}
</script>